/*
 * Copyright 2019 NEM
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Catapult REST API Reference
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.7.15
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';
import MultisigAccountInfoDTO from './MultisigAccountInfoDTO';





/**
* The MultisigAccountGraphInfoDTO model module.
* @module model/MultisigAccountGraphInfoDTO
* @version 0.7.15
*/
export default class MultisigAccountGraphInfoDTO {
    /**
    * Constructs a new <code>MultisigAccountGraphInfoDTO</code>.
    * @alias module:model/MultisigAccountGraphInfoDTO
    * @class
    * @param level {Number} The level of the multisig account.
    * @param multisigEntries {Array.<module:model/MultisigAccountInfoDTO>} The array of multisig accounts for this level.
    */

    constructor(level, multisigEntries) {
        

        
        



        this['level'] = level;this['multisigEntries'] = multisigEntries;

        
    }

    /**
    * Constructs a <code>MultisigAccountGraphInfoDTO</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/MultisigAccountGraphInfoDTO} obj Optional instance to populate.
    * @return {module:model/MultisigAccountGraphInfoDTO} The populated <code>MultisigAccountGraphInfoDTO</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MultisigAccountGraphInfoDTO();

            
            
            

            if (data.hasOwnProperty('level')) {
                obj['level'] = ApiClient.convertToType(data['level'], 'Number');
            }
            if (data.hasOwnProperty('multisigEntries')) {
                obj['multisigEntries'] = ApiClient.convertToType(data['multisigEntries'], [MultisigAccountInfoDTO]);
            }
        }
        return obj;
    }

    /**
    * The level of the multisig account.
    * @member {Number} level
    */
    level = undefined;
    /**
    * The array of multisig accounts for this level.
    * @member {Array.<module:model/MultisigAccountInfoDTO>} multisigEntries
    */
    multisigEntries = undefined;








}


